import { render } from "./PasswordRequirements.vue?vue&type=template&id=33627f79"
import script from "./PasswordRequirements.vue?vue&type=script&lang=js"
export * from "./PasswordRequirements.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__